import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createActionGroup, createFeature, createReducer, createSelector, on, props } from '@ngrx/store';
import { GoalGroupRootInterface } from '../../goal-group/goal-group.service.interface';

export const NAME = 'goalGroups';

export type State = EntityState<GoalGroupRootInterface>;

export const adapter: EntityAdapter<GoalGroupRootInterface> = createEntityAdapter<GoalGroupRootInterface>();

export const initialState: State = adapter.getInitialState();

export const actions = createActionGroup({
  source: 'GoalGroups',
  events: {
    'Upsert Goal Groups': props<{ goalGroups: GoalGroupRootInterface[] }>(),
  },
});

export const feature = createFeature({
  name: NAME,
  reducer: createReducer(
    initialState,
    on(actions.upsertGoalGroups, (state, { goalGroups }): State => adapter.upsertMany(goalGroups, state))
  ),
});

/**
 * Null-safe display name for a goal group breadcrumb: "<method> - <learningArea>",
 * matching what the goal header shows. Returns '' while the group isn't (yet)
 * in the store, so route data (breadcrumbs) can't crash on it.
 *
 * Standalone props-selector: `createFeature`'s `extraSelectors` only accepts
 * single-argument selectors or selector factories.
 */
export const selectName = createSelector(feature.selectEntities, (entities, byId: { id: number }): string => {
  const goalGroup = entities[byId.id];
  return goalGroup ? `${goalGroup.method} - ${goalGroup.learningArea}` : '';
});
